// extracted by mini-css-extract-plugin
module.exports = {"modal":"custom-modal_modal__1g68i","closeIcon":"custom-modal_closeIcon__3V4Me"};